<template>
  <div>
    <v-row>
      <v-spacer />
      <v-switch class="mr-2" v-model="hidden" label="Hidden"></v-switch>
    </v-row>
    <learning-item-view
      :item="item"
      :responses-complete="false"
      :show-complete="true"
    />
  </div>
</template>
<script>
import LearningItemView from "@/containers/learnings/LearningItemView"
import eventMixin from "@/mixins/eventMixin"

export default {
  mixins: [eventMixin],
  components: {
    LearningItemView
  },
  data() {
    return {
      learningItemId: this.$route.params.id
    }
  },
  created() {
    this.addListener("learningResponse:save", model => {
      this.$store.dispatch("learningItems/updateLearningItemResponse", {
        id: model.id,
        learningItemId: model.learning_item_id,
        value: model.value
      })
    })
  },
  computed: {
    hidden: {
      get() {
        return this.item.hidden
      },
      set(value) {
        this.$store.dispatch("learningItems/updateLearningItem", {
          id: this.item.id,
          hidden: value
        })
      }
    },
    item() {
      let item = this.$store.getters["learningItems/getLearningItemById"](
        this.learningItemId
      )
      return item ? item : {}
    }
  }
}
</script>
